// extracted by mini-css-extract-plugin
export default {"system":"System_system__uNELY","info":"System_info__UuzeN","systemBody":"System_systemBody__sntsM"};